module.exports = __webpack_public_path__ + "static/media/close.1249da4b.svg";